export const whatAwaits = [
    {
        id: 1,
        card: '/images/whatAwaits1.png',
    },
    {
        id: 2,
        card: '/images/whatAwaits2.png',
    },
    {
        id: 3,
        card: '/images/whatAwaits3.png',
    },
    {
        id: 4,
        card: '/images/whatAwaits4.png',
    },
    {
        id: 5,
        card: '/images/whatAwaits5.png',
    },
    {
        id: 6,
        card: '/images/whatAwaits6.png',
    },
];
